// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-recover-password[data-v-8513862e]{font-family:Roboto,sans-serif;font-style:normal;font-weight:500;font-size:20px;line-height:22px;padding-top:20px}.description-recover-password[data-v-8513862e]{font-family:Roboto,sans-serif;font-style:normal;font-size:16px;line-height:24px;padding-bottom:24px}.rounded-box[data-v-8513862e]{margin:24px 0 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
